import Yup from '_zari/validation/_yup'

const parseDDMMYYYY = str => {
  if (!str) return null
  const [d, m, y] = str.split('/')
  if (!d || !m || !y) return null
  return new Date(parseInt(y), parseInt(m) - 1, parseInt(d))
}

export const ValidationSchema = Yup.object().shape({
  glosa: Yup.string().required(),
  fechaEmision: Yup.string().required(),
  fechaNecesidad: Yup.string()
    .required('Fecha de requerimiento es requerida.')
    .test('mayor-a-emision', 'Debe ser mayor o igual a la fecha de emisión.', function (value) {
      const fechaEmision = parseDDMMYYYY(this.parent.fechaEmision)
      const fechaNecesidad = parseDDMMYYYY(value)
      if (!fechaEmision || !fechaNecesidad) return true
      return fechaNecesidad >= fechaEmision
    })
})
